import React, { useState } from 'react';
import RoleManagementTab from '../components/system/RoleManagementTab';
import AuthSettingsTab from '../components/system/AuthSettingsTab';
import GroupMappingsTab from '../components/system/GroupMappingsTab';
import UserManagementTab from '../components/system/UserManagementTab';
import RetentionSettingsTab from '../components/system/RetentionSettingsTab';
import AboutTab from '../components/system/AboutTab';

type TabId = 'roles' | 'auth' | 'groups' | 'users' | 'retention' | 'about';

interface Tab {
  id: TabId;
  label: string;
}

const TABS: Tab[] = [
  { id: 'roles', label: 'Role Management' },
  { id: 'auth', label: 'Authentication' },
  { id: 'groups', label: 'Group Mappings' },
  { id: 'users', label: 'Users' },
  { id: 'retention', label: 'Settings' },
  { id: 'about', label: 'About' },
];

const SystemPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabId>('roles');

  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <div className="px-4 py-6 sm:px-0">
        <h1 className="text-2xl font-semibold text-gray-900 mb-6">System Configuration</h1>

        {/* Tab navigation */}
        <div className="border-b border-gray-200 mb-6">
          <nav className="-mb-px flex space-x-8" aria-label="System tabs">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
                aria-selected={activeTab === tab.id}
                role="tab"
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Tab content panels — all rendered, only active is visible (preserves state) */}
        <div style={{ display: activeTab === 'roles' ? 'block' : 'none' }} role="tabpanel">
          <RoleManagementTab />
        </div>
        <div style={{ display: activeTab === 'auth' ? 'block' : 'none' }} role="tabpanel">
          <AuthSettingsTab />
        </div>
        <div style={{ display: activeTab === 'groups' ? 'block' : 'none' }} role="tabpanel">
          <GroupMappingsTab />
        </div>
        <div style={{ display: activeTab === 'users' ? 'block' : 'none' }} role="tabpanel">
          <UserManagementTab />
        </div>
        <div style={{ display: activeTab === 'retention' ? 'block' : 'none' }} role="tabpanel">
          <RetentionSettingsTab />
        </div>
        <div style={{ display: activeTab === 'about' ? 'block' : 'none' }} role="tabpanel">
          <AboutTab />
        </div>
      </div>
    </div>
  );
};

export default SystemPage;
